import { bpost} from "../config/httpRequest.js"
const route = 'index'

//最新活动
export async function latestEvents() {
  return bpost({
    url: route + "/activity/latestEvents",
  })
}

// 产品与服务
export async function list() {
  return bpost({
    url: route + "/service/list",
  })
}

//案例
export async function caseslist() {
  return bpost({
    url: route + "/cases/list",
  })
}

//新闻中心
export async function Newslist() {
  return bpost({
    url: route + "/news/list",
  })
}

//banner
export async function Bannerlist() {
  return bpost({
    url: route + "/banner/list",
  })
}



//////////////////
// WEBPACK FOOTER
// ./api/index.js
// module id = null
// module chunks = 